export default function LockIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <g clip-path="url(#clip0_1249_15317)">
        <path
          d="M12.6667 5.33338H11.9048V3.80957C11.9048 1.70671 10.1981 4.57764e-05 8.09524 4.57764e-05C5.99238 4.57764e-05 4.28571 1.70671 4.28571 3.80957V5.33338H3.52381C2.68571 5.33338 2 6.01909 2 6.85719V14.4762C2 15.3143 2.68571 16 3.52381 16H12.6667C13.5048 16 14.1905 15.3143 14.1905 14.4762V6.85719C14.1905 6.01909 13.5048 5.33338 12.6667 5.33338ZM8.09524 12.1905C7.25714 12.1905 6.57143 11.5048 6.57143 10.6667C6.57143 9.82862 7.25714 9.1429 8.09524 9.1429C8.93333 9.1429 9.61905 9.82862 9.61905 10.6667C9.61905 11.5048 8.93333 12.1905 8.09524 12.1905ZM10.4571 5.33338H5.73333V3.80957C5.73333 2.50671 6.79238 1.44766 8.09524 1.44766C9.3981 1.44766 10.4571 2.50671 10.4571 3.80957V5.33338Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_1249_15317">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
